export default __webpack_public_path__ + "5a680efdc0334e1577a662a4b7912ebd.svg";